export default {
	props: {
		minGuests: {type:Number, default: 1},
		maxGuests: {type:Number,default: 1},
		guestsAgesRequired: {type:Boolean, default:true},
		childrenAges: {type:Array, default:()=>null},
		value:{type:Array, default:()=>([])},
		errors:{type:Object, default:()=>({})},
	},
	data(){
		return {
			innerValue: [],
			adultAge:-1,
		}
	},
	watch:{
		value:{
			immediate: true,
			handler(){
				let tmp = [];
				if(this.value.length>=this.minGuests && this.value.length<=this.maxGuests){
					tmp = this.value;
				}
				else {
					for(let i=0;i<this.maxGuests;i++){
						if(this.value[i] || this.minGuests>i){
							let item = {
								first_name: this.value[i] && this.value[i].first_name!=null ? this.value[i].first_name : '',
								last_name: this.value[i] && this.value[i].last_name!=null ? this.value[i].last_name : ''
							};
							if(this.guestsAgesRequired){
								item.age = this.value[i] && this.value[i].age!=null ? this.value[i].age : '';
								if(i===0){
									item.age=this.adultAge;
								}
							}
							tmp.push(item);
						}
					}
				}

				this.innerValue = tmp;
			},
		},
		innerValue:{
			immediate: true,
			handler(newValue,oldValue){
				this.$emit('input', this.innerValue);
			},
		},
	},
	computed:{
		maxGuestsReached(){
			return this.innerValue.length>=this.maxGuests;
		},
	},
	methods: {
		addGuestBtnVisible(i){
			return !this.maxGuestsReached && i+1===this.innerValue.length;
		},
		addGuest(){
			if(!this.maxGuestsReached){
				const item = {first_name:'', last_name:''};
				if(this.guestsAgesRequired) item.age='';

				this.$set(this.innerValue, this.innerValue.length, item);
			}
		},
		getAgesOptions(indx){
			const tmp = [];
			tmp.push({value:this.adultAge, label:this.$t('adult')});

			if(indx>0 && this.childrenAges){
				for(const age of this.childrenAges){
					tmp.push({value:age, label:this.$t('child')+' '+this.$tc('childrenAge',age)});
				}
			}
			return tmp;
		},
		removeGuest(i){
			if(i+1>this.minGuests) {
				this.innerValue.splice(i,1);
			} else {
				alert("Can't remove the guest!");
			}
		}
	},
	template: `
<div class="rra-item-quests">
	<div class="rra-item-quest" v-for="(v,i) in innerValue" :key="i">
		<div class="col1">
			<b v-t="'guest'"></b> {{i+1}}<br /><span class="qicon-1 guest-remove-btn" v-if="i+1>minGuests" @click="removeGuest(i)">remove</span>
		</div>
		<div :class="['col2', guestsAgesRequired?'ages-yes':'ages-no']">
			<div><qit-input class="v1" :label="$t('client.nameFirst')" v-model="v.first_name" :error-msg="errors[i]&&errors[i].first_name?errors[i].first_name:''"></qit-input></div>
			<div><qit-input class="v1" :label="$t('client.nameLast')" v-model="v.last_name" :error-msg="errors[i]&&errors[i].last_name?errors[i].last_name:''"></qit-input></div>
			<div v-if="guestsAgesRequired">
				<qit-select class="v1" :label="$t('client.age')" v-model="v.age" :error-msg="errors[i]&&errors[i].age?errors[i].age:''"
				:options="getAgesOptions(i)"
				label-disabled></qit-select>
			</div>
		</div>
		<div class="col3">
			<a class="guest-add-btn" v-if="addGuestBtnVisible(i)" @click="addGuest">+ <span v-t="'client.addGuest'"></span></a>
		</div>
	</div>
</div>
`,
}
